import { render, staticRenderFns } from "./PostCardProtagonist.vue?vue&type=template&id=214c6b7b"
import script from "./PostCardProtagonist.vue?vue&type=script&lang=js"
export * from "./PostCardProtagonist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports